import script from "./ActivityLog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityLog.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityLog.vue?vue&type=style&index=0&id=b1738a0e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1738a0e"]])

export default __exports__